import { useState } from 'react';
import { api } from '../partage/api/client';
import { useSession } from '../partage/useArbre';
import './Connexion.css';

/** « Plus tard » tient jusqu'à la prochaine connexion : gardé pour l'onglet, jamais dans le compte. */
const CLE_PLUS_TARD = 'nextilt.bandeau-adresse.plus-tard';

function lirePlusTard(): boolean {
  try {
    return window.sessionStorage.getItem(CLE_PLUS_TARD) === 'oui';
  } catch {
    return false;
  }
}

function noterPlusTard(): void {
  try {
    window.sessionStorage.setItem(CLE_PLUS_TARD, 'oui');
  } catch {
    // Sans stockage, le bandeau se cache pour cette page seulement.
  }
}

/**
 * Le bandeau des comptes d'avant (chantier mails, décision 3 d'Igor ; maquette connexion.html,
 * section 4) : en haut de l'accueil, pour un compte dont l'adresse n'est pas vérifiée. L'app
 * reste utilisable. « M'envoyer le lien » passe par la session, sans rien taper.
 */
export function BandeauAdresse() {
  const session = useSession();
  const [cache, setCache] = useState(lirePlusTard);
  const [envoye, setEnvoye] = useState(false);
  const [enCours, setEnCours] = useState(false);

  const aVerifier = session.data?.connecte === true && typeof session.data.email === 'string' && session.data.emailVerifie === false;
  if (!aVerifier || cache) return null;

  async function envoyer() {
    if (enCours) return;
    setEnCours(true);
    try {
      await api.renvoyerVerification();
      setEnvoye(true);
    } catch {
      // Pas de réseau ou trop de tentatives : le bouton reste, on réessaiera.
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="bandeau-adresse" role="status">
      <b>Vérifie ton adresse</b>
      <span>
        {envoye
          ? `Un lien vient de partir vers ${session.data!.email}. Il vaut 48 heures.`
          : 'Pour pouvoir retrouver ton compte si tu oublies ton mot de passe.'}
      </span>
      <span className="bandeau-adresse-actions">
        {!envoye && (
          <button type="button" className="connexion-second" onClick={envoyer} disabled={enCours}>
            {enCours ? 'Un instant' : 'M’envoyer le lien'}
          </button>
        )}
        <button
          type="button"
          className="bandeau-adresse-plus-tard"
          onClick={() => {
            noterPlusTard();
            setCache(true);
          }}
        >
          {envoye ? 'Fermer' : 'Plus tard'}
        </button>
      </span>
    </div>
  );
}
